module.exports = __webpack_public_path__ + "img/avatar-f1.e6cd2cde.png";